import { useState, useCallback } from 'react';

interface UseAddNoteDialogReturn {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

export const useAddNoteDialog = (): UseAddNoteDialogReturn => {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return {
    open,
    openDialog,
    closeDialog
  };
};
